export const submit = async observer => {
  const isValid = await observer.validate()
  return isValid
}

export const openModal = async (instance, data) => {
  instance.$modal.show(
    () => import('src/components/app/Modals/ModalAnswer'),
    {
      message: data,
    }, {
      resizable: true,
      maxWidth: 800,
      height: 'auto',
      adaptive: true,
      scollable: true,
      classes: 'thx-modal',
    }
  )
}

export const resetForm = dataForm => {
  const pureObject = { ...dataForm }
  Object.keys(pureObject).forEach(key => {
    pureObject[key] = ''
  })
  return pureObject
}



// WEBPACK FOOTER //
// ./src/js/components/app/Forms/utils.js